import { routes } from 'utils/routes'
import { Language } from 'types/language'
import { isValidLowercaseLanguage } from 'utils/language'

/**
 * Get the USP link from the i18n key
 * @param {string} key
 * @param {string} language
 * @returns {string}
 */
export const getUspLinkFromKey = (key: string, language: string): string => {
  const locale = isValidLowercaseLanguage(language) ? language : Language.DUTCH

  switch (key) {
    case 'fun': {
      return routes(locale).uspsFun
    }
    case 'durable': {
      return routes(locale).uspsLocal
    }
    case 'service': {
      return routes(locale).uspsCustomerCare
    }
    case 'tariff': {
      return routes(locale).uspsFairPrice
    }
    default: {
      return routes(locale).uspsOverview
    }
  }
}
